export default "__VITE_ASSET__DYJH9NFM__"